import { required } from "vuelidate/lib/validators";
const StrBirimButceHarcamalariTutarlari = {
  data() {
    return {
      StrBirimButceHarcamalariTutarlariData: {
        Tutar: "",
        Kdv: "",
        Kdvsiz: "",
        Birimbutceharcamalariid: "",
        Hesapkodlariid: null,
        Okaskoduid: null,
        Iskalemadi: null,
        Olcubirimiid: null,
        Adet: "",
        Birimfiyat: "",

      },
      FormDataType: {
        Hesapkodlariid: {
          FieldName: "Hesapkodlariid",
          Field: "combobox",
          FieldTitle: this.$t(
            "StrBirimButceHarcamalariTutarlari.AddEdit.Hesapkodlariid"
          ),
          ComboDataArray: [],
        },
        Kdvsiz: {
          FieldName: "Kdvsiz",
          Field: "input",
          FieldTitle: this.$t(
            "StrBirimButceHarcamalariTutarlari.AddEdit.Kdvsiz"
          ),
          FieldType: "number",
        },
        Kdv: {
          FieldName: "Kdv",
          Field: "input",
          FieldTitle: this.$t("StrBirimButceHarcamalariTutarlari.AddEdit.Kdv"),
          FieldType: "number",
        },
        
        Okaskoduid: {
          FieldName: "Okaskoduid",
          Field: "combobox",
          FieldTitle: this.$t(
            "StrBirimButceHarcamalariTutarlari.AddEdit.Okaskodu"
          ),
          ComboDataArray:  [],
          Disabled:"Disabled"
        },
        Iskalemadi: {
          FieldName: "Iskalemadi",
          Field: "input",
          FieldTitle: this.$t(
            "StrBirimButceHarcamalariTutarlari.AddEdit.Iskalemadi"
          ),
        },
        Olcubirimiid: {
          FieldName: "Olcubirimiid",
          Field: "combobox",
          FieldTitle: this.$t(
            "StrBirimButceHarcamalariTutarlari.AddEdit.Olcubirimi"
          ),
          ComboDataArray: [],
        },
        Adet: {
          FieldName: "Adet",
          Field: "input",
          FieldTitle: this.$t("StrBirimButceHarcamalariTutarlari.AddEdit.Adet"),
          FieldType: "number",
        },
        Birimfiyat: {
          FieldName: "Birimfiyat",
          Field: "input",
          FieldTitle: this.$t(
            "StrBirimButceHarcamalariTutarlari.AddEdit.Birimfiyat"
          ),
          FieldType: "number",
        },
      },
    };
  },
  validations: {
    FormData: {
      Hesapkodlariid: { required },
      Kdvsiz: { required },
      Kdv: { required },
      Okaskoduid: {},
      Iskalemadi: {},
      Olcubirimiid: {},
      Adet: {},
      Birimfiyat: {},
  
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsGet({ Service: "StrHesapKodlari", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Hesapkodlariid.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].Aciklama,
        });
      }
    });
    this.ActionsSabitGet(201).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Olcubirimiid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
  },
};
export default StrBirimButceHarcamalariTutarlari;
